import _ from 'lodash';

import {
  getSeasonEpisodeCounts,
  getNetworkList,
  getAuthorizingNetwork,
  getRequiresAuth,
  isEpisode,
} from 'helpers/ContentHelper';
import { getPlayerCsid } from 'helpers/PlayerHelper';
import { VIDEO_TYPE_CLIP } from 'screens/Watch/WatchHelpers';

export const getVideoContainerProps = item => {
  if (!item) return null;

  const fallbackBackground = _.get(item, 'images.still.raw', null);
  const background = _.get(item, 'images.seriesStill.raw', fallbackBackground);
  const siteSection = getPlayerCsid({
    showCode: item.showCode,
    isFullEpisode: isEpisode(item.videoType),
  });
  const requiresAuth = getRequiresAuth({ video: item });
  const requiresAuthLive = getRequiresAuth({ video: item, isLive: true });
  const scrubbingEnabled = _.get(item, 'scrubbingEnabled', null);
  const videoType = _.get(item, 'videoType', null);
  const networkEntitlementList = getNetworkList();
  const authorizingNetwork = getAuthorizingNetwork(item);
  const creditCuePoint = _.get(item, 'creditCuePoint', null);
  const contentRating = _.get(item, 'contentRating');
  const contentSKU = _.get(item, 'contentSKU');
  const videoId = _.get(item, 'id');
  const network = _.get(item, 'network');
  const contentNetworks = _.get(item, 'networks') || [network];

  const scrubbingEnabledCalc = scrubbingEnabled || videoType === VIDEO_TYPE_CLIP;
  const props = {
    authorizingNetwork,
    background,
    contentNetworks,
    contentRating,
    contentSKU,
    creditCuePoint,
    network,
    networkEntitlementList,
    playerLoadingImage: background,
    requiresAuth,
    requiresAuthLive,
    selectedVideo: videoId,
    siteSection,
    scrubbingEnabled: scrubbingEnabledCalc,
    videoId,
    videoType,
  };
  return props;
};

export const getWatchDetailProps = item => {
  if (!item) return null;

  const title = _.get(item, 'name');
  const episodeCount = _.get(item, 'fullEpisodeCount');
  const seasonCount = _.get(item, 'seasonCount');
  const subtitleFallback = getSeasonEpisodeCounts({
    seasonCount,
    episodeCount,
    useComma: true,
  });
  const showSubtitle = _.get(item, 'showSubtitle', subtitleFallback);
  const metadata = _.get(item, 'metadata');
  const description = _.get(item, 'description');
  const showCode = _.get(item, 'showCode');
  const seriesType = _.get(item, 'seriesType');
  const titleLink = _.get(item, 'titleLink');

  const props = {
    description,
    disableFavorite: true,
    metadata,
    seriesType,
    seriesScreenUrl: titleLink,
    showCode,
    showControls: true,
    showSubtitle,
    title,
  };
  return props;
};

export const getActionButtons = item => {
  const actionButtons = [];
  if (!item) return actionButtons;

  const watchLink = _.get(item, 'watchLink');
  if (watchLink) {
    const { global_watchButton: watchButtonText } = window.Language;
    const seasonEpisode = _.get(item, 'seriesSeasonEpisode');
    const watchText = `${watchButtonText} ${seasonEpisode}`;
    const lockButtons = _.get(item, 'lockButtons');

    actionButtons.push({
      icon: lockButtons ? 'lock' : 'play-button',
      viewBox: lockButtons ? '-7 -1 30 30' : null,
      text: watchText,
      url: watchLink,
    });
  }

  return actionButtons;
};

export const parseVideoResponse = data => data;
